/**
 * What this bundle was built from.
 *
 * Vite substitutes `import.meta.env.VITE_*` at BUILD time — a static bundle has
 * no runtime environment to read — so `infra/docker/admin.Dockerfile` sets these
 * before `vite build` from the same build args the API image is stamped with.
 *
 * The defaults are what `pnpm dev` produces. Seeing one of them on a deployed
 * stack is itself the finding: that bundle did not come out of CI.
 */
export interface BuildInfo {
  version: string;
  /** Full commit SHA, or `local`. */
  commit: string;
  /** ISO 8601, or `unknown`. */
  builtAt: string;
}

function read(name: string, fallback: string): string {
  const value = import.meta.env[name] as string | undefined;
  return value === undefined || value === "" ? fallback : value;
}

export const BUILD: BuildInfo = {
  version: read("VITE_BUILD_VERSION", "0.0.0-dev"),
  commit: read("VITE_BUILD_COMMIT", "local"),
  builtAt: read("VITE_BUILD_TIME", "unknown"),
};

/**
 * The first seven characters of a SHA, which is what `git log --oneline` shows
 * and what a person can actually compare by eye.
 *
 * `local` and other non-SHA markers pass through whole — truncating them to
 * `local` would be lossless by luck and `unknow` on the next marker.
 */
export function shortCommit(commit: string): string {
  return /^[0-9a-f]{40}$/i.test(commit) ? commit.slice(0, 7) : commit;
}

/** `2026-09-08T13:04:11Z` -> `8 Sep 2026, 13:04 UTC`. Left alone if unparseable. */
export function formatBuildTime(builtAt: string): string {
  const parsed = new Date(builtAt);
  if (Number.isNaN(parsed.getTime())) return builtAt;
  return `${parsed.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
  })} UTC`;
}
